var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "unum-header", attrs: { id: "unum-header" } },
    [
      _c("div", { staticClass: "unum-header__left" }, [
        _c(
          "a",
          {
            staticClass: "logo",
            attrs: { href: "#", tabindex: "1" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.logoClickEvent($event)
              }
            }
          },
          [_vm._v("Colonial Life EPS")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "unum-header__right" },
        [
          _vm.$route.name === "Compare" ||
          _vm.$route.name === "Final" ||
          _vm.$route.name === "FinalSelection"
            ? _c(
                "button",
                {
                  staticClass: "print-button",
                  on: {
                    click: function($event) {
                      return _vm.print()
                    }
                  }
                },
                [_vm._v("Print")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h1", { staticClass: "app-title" }, [
            _vm._v("Tech Platform Assistant")
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
            _c(
              "button",
              {
                staticClass: "menu-toggle",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toggleDrawerEvent($event)
                  }
                }
              },
              [_vm._v("\n        Toggle Menu\n      ")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e628c52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e628c52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Header.vue
// module id = null
// module chunks = 